import * as yup from "yup";

const model = {
  tripType: "",
  tripTypeId: 0,
  flightDates: "",
  flightLegs: {
    onward: [
      {
        flightNumber: "",
        airportDepartureId: "",
        airportDestinationId: "",
        flightCarrierId: "",
        checkInBaggage: "",
        fareType: "",
        cabinBaggage: "",
        arrivalTime: "",
        departureTime: "",
      },
    ],
  },
  isPnrRequired: true,
  seats: 1,
  pnr: "",
  refundable: 0,
  adultBaseFare: 0,
  adultYQ: 0,
  adultTotalTaxPerSeat: 0,
  childBaseFare: 0,
  childYQ: 0,
  childTotalTaxPerSeat: 0,
  infrantBaseFare: 0,
  infrantYQ: 0,
  infrantTotalTaxPerSeat: 0,
  commEmailOne: "",
  commEmailTwo: "",
};
const numberRequiredMinZero = (msg) =>
  yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" ? undefined : value,
    )
    .min(0, "Value must be 0 or greater")
    .required(msg);
const validationModel = yup.object().shape({
  tripType: yup.string().optional("Please Select Trip type"),
  //   tripTypeId: yup.string().optional("Please Select Trip ID"),
  // flightNumber: yup.string().required("Please Enter Flight Number"),
  // flightDates: yup.string().required("Please Select Flight Date"),
  seats: yup
    .number()
    .integer("Invalid seat count")
    .min(1, "Please select at least 1 seat")
    .required("Please select seat"),

  isPnrRequired: yup.boolean().required("Please Select PNR options"),
  //pnr: yup.string().required("please Enter PNR Number"),
  pnr: yup.string().when("isPnrRequired", {
    is: true,
    then: yup.string().required("please Enter PNR Number"),
  }),
  refundable: yup.boolean().optional(),
  tripTypeId: yup.number().optional("Please Select Trip ID"),
  adultBaseFare: numberRequiredMinZero("Please Select Adult Base Fare"),
  adultYQ: numberRequiredMinZero("Please Select Adult YQ"),
  adultTotalTaxPerSeat: numberRequiredMinZero("Please Enter Adult Total Tax "),

  childBaseFare: numberRequiredMinZero("Please Enter Child Base Fare"),
  childYQ: numberRequiredMinZero("Please Enter Child YQ"),
  childTotalTaxPerSeat: numberRequiredMinZero("Please Enter Child Total Tax"),

  infrantBaseFare: numberRequiredMinZero("Please Enter Infant Base Fare"),
  infrantYQ: numberRequiredMinZero("Please Enter Infant YQ"),
  infrantTotalTaxPerSeat: numberRequiredMinZero(
    "Please Enter Infant Total Tax",
  ),
  commEmailOne: yup
    .string()
    .required("Please enter Person-1 Email")
    .email("Please enter a valid email"),
  commEmailTwo: yup.string().optional().email("Please enter a valid email"),

  flightLegs: yup.object().shape({
    onward: yup
      .array()
      .of(
        yup.object().shape({
          flightNumber: yup.string().required("Please Enter Flight number"),
          airportDepartureId: yup
            .string()
            .required("Please Enter Airport Departure"),
          airportDestinationId: yup
            .string()
            .required("Please Enter Airport Destination"),
          flightCarrierId: yup.number().required("Please Enter Carrier"),
          checkInBaggage: yup
            .string()
            .optional("Please Enter Check In Baggage"),
          fareType: yup.string().optional("Please Enter Fare Type"),
          arrivalTime: yup.string().required("Please Enter Arrival Time"),
          departureTime: yup.string().required("Please Enter Departure Time"),
        }),
      )
      .optional(),
  }),
});

const newValidationSchema = yup.object().shape({
  tripType: yup.string().optional("Please Select Trip type"),
  //   tripTypeId: yup.string().optional("Please Select Trip ID"),
  // flightNumber: yup.string().optional("Please Enter Flight Number"),
  // flightDates: yup.string().optional("Please Select Flight Date"),
  seats: yup
    .number()
    .integer("Invalid seat count")
    .min(1, "Please select at least 1 seat")
    .required("Please select seat"),

  isPnrRequired: yup.boolean().required("Please Select PNR options"),
  //  pnr: yup.string().optional("please Enter PNR Number"),
  pnr: yup.string().when("isPnrRequired", {
    is: true,
    then: yup.string().required("please Enter PNR Number"),
  }),
  refundable: yup.boolean().optional(),
  tripTypeId: yup.number().optional("Please Select Trip ID"),
  adultBaseFare: yup.number().optional("Please Select Adult Base Fare"),
  adultYQ: yup.number().optional("Please Select Adult YQ"),
  adultTotalTaxPerSeat: yup
    .number()
    .optional("Please Enter Adult Total Tax Per Seat"),
  childBaseFare: yup.number().optional("Please Enter Child Total Tax Per Seat"),
  childYQ: yup.number().optional("Please Enter Child YQ"),
  childTotalTaxPerSeat: yup
    .number()
    .optional("Please Enter Child Total Tax Per Seat"),
  infrantBaseFare: yup.number().optional("Please Enter Infant Base Fare"),
  infrantYQ: yup.number().optional("Please Enter infant YQ"),
  infrantTotalTaxPerSeat: yup
    .number()
    .optional("Please Enter Infant Total Tax Per Seat"),
  commEmailOne: yup
    .string()
    .optional("Please enter Person-1 Email")
    .email("Please enter a valid email"),
  commEmailTwo: yup.string().optional().email("Please enter a valid email"),

  flightLegs: yup.object().shape({
    onward: yup
      .array()
      .of(
        yup.object().shape({
          flightNumber: yup.string().required("Please Enter Flight number"),
          airportDepartureId: yup
            .string()
            .required("Please Enter Airport Departure"),
          airportDestinationId: yup
            .string()
            .required("Please Enter Airport Destination"),
          flightCarrierId: yup.number().required("Please Enter Carrier"),
          checkInBaggage: yup
            .string()
            .optional("Please Enter Check In Baggage"),
          fareType: yup.string().optional("Please Enter Fare Type"),
          arrivalTime: yup.string().required("Please Enter Arrival Time"),
          departureTime: yup.string().required("Please Enter Departure Time"),
        }),
      )
      .optional(),

    return: yup
      .array()
      .of(
        yup.object().shape({
          flightNumber: yup.string().required("Please Enter Flight number"),
          airportDepartureId: yup
            .string()
            .required("Please Enter Airport Departure"),
          airportDestinationId: yup
            .string()
            .required("Please Enter Airport Destination"),
          flightCarrierId: yup.number().required("Please Enter Carrier"),
          checkInBaggage: yup
            .string()
            .optional("Please Enter Check In Baggage"),
          fareType: yup.string().optional("Please Enter Fare Type"),
          arrivalTime: yup.string().required("Please Enter Arrival Time"),
          departureTime: yup.string().required("Please Enter Departure Time"),
        }),
      )
      .optional(),
  }),
});

const tripTypeOptions = [
  { value: 1, label: "One Way" },
  // { value: 2, label: "Round Trip" },
  // { value: 3, label: 'Multicity' },
];
const refundableOption = [
  { value: 1, label: "Refundable" },
  { value: 2, label: "Partial Refundable" },
  { value: 0, label: "Non Refundable" },
];
export {
  model,
  validationModel,
  tripTypeOptions,
  newValidationSchema,
  refundableOption,
};
